import {createSlice} from "@reduxjs/toolkit";

const locationSlice = createSlice({
    name: "locationRedux",
    initialState: {
        locations: []
    },
    reducers: {
        addLocation: (state, action) => {
            state.locations.push(action.payload);
        },

        editLocation: (state, action) => {
            const updatedLocation = action.payload;
            for(const item of state.locations){
                if(item.locationId === updatedLocation.locationId){
                    item.locationName = updatedLocation.locationName;
                    item.locationDesc = updatedLocation.locationDesc;
                    item.locationHead = updatedLocation.locationHead;
                    break;
                }
            }
            
        },
        
    }
});

export const {addLocation, editLocation} = locationSlice.actions;
export default locationSlice.reducer;